var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-notifications',{attrs:{"show_mark_all_btn":true,"show_see_all_btn":true,"url":"https://jsonplaceholder.typicode.com/todos?userId=1","mark_all_btn_url":"https://jsonplaceholder.typicode.com/posts","read_key":"completed","icon":"fa fa-bell"},scopedSlots:_vm._u([{key:"custom",fn:function(ref){
var data = ref.data;
return [_vm._v("\n          "+_vm._s(data)+"\n        ")]}},{key:"body",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(item.title)+"\n          ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }